export enum FileTypes {
  UNKNOWN,
  FILE_SECURE,
  FOLDER,
  FOLDER_SECURE,
  MULTIPLE_FILES,
  MULTIPLE_SECURE_FILES,
  AUDIO,
  CODE,
  EXCEL,
  EXECUTABLE,
  IMAGE,
  MOVIE,
  PDF,
  POWERPOINT,
  TEXT,
  WORD,
  ZIP
}

export const FileTypeIconUrls: Record<FileTypes, string> = {
  [FileTypes.UNKNOWN]: '/assets/images/suite/storage/file-icons/icon_unknown.svg',
  [FileTypes.FOLDER]: '/assets/images/suite/storage/file-icons/icon_folder.svg',
  [FileTypes.FILE_SECURE]: '/assets/images/suite/storage/file-icons/icon_secure.svg',
  [FileTypes.FOLDER_SECURE]: '/assets/images/suite/storage/file-icons/icon_foldersecure.svg',
  [FileTypes.MULTIPLE_FILES]: '/assets/images/suite/storage/file-icons/icon_multiple.svg',
  [FileTypes.MULTIPLE_SECURE_FILES]: '/assets/images/suite/storage/file-icons/icon_multiplesecure.svg',
  [FileTypes.AUDIO]: '/assets/images/suite/storage/file-icons/icon_audio.svg',
  [FileTypes.CODE]: '/assets/images/suite/storage/file-icons/icon_code.svg',
  [FileTypes.EXCEL]: '/assets/images/suite/storage/file-icons/icon_excel.svg',
  [FileTypes.EXECUTABLE]: '/assets/images/suite/storage/file-icons/icon_exec.svg',
  [FileTypes.IMAGE]: '/assets/images/suite/storage/file-icons/icon_image.svg',
  [FileTypes.MOVIE]: '/assets/images/suite/storage/file-icons/icon_movie.svg',
  [FileTypes.PDF]: '/assets/images/suite/storage/file-icons/icon_pdf.svg',
  [FileTypes.POWERPOINT]: '/assets/images/suite/storage/file-icons/icon_powpt.svg',
  [FileTypes.TEXT]: '/assets/images/suite/storage/file-icons/icon_text.svg',
  [FileTypes.WORD]: '/assets/images/suite/storage/file-icons/icon_word.svg',
  [FileTypes.ZIP]: '/assets/images/suite/storage/file-icons/icon_zip.svg',
};

export const FileExtensions: Record<string, FileTypes> = {
  // WORD files
  'doc': FileTypes.WORD,
  'docx': FileTypes.WORD,
  'odt': FileTypes.WORD,
  'rtf': FileTypes.WORD,
  'wpd': FileTypes.WORD,
  'wps': FileTypes.WORD,
  'abw': FileTypes.WORD,
  'lwp': FileTypes.WORD,
  'pages': FileTypes.WORD,
  'dot': FileTypes.WORD,
  'dotx': FileTypes.WORD,

  // EXCEL files
  'xls': FileTypes.EXCEL,
  'xlsx': FileTypes.EXCEL,
  'xlsm': FileTypes.EXCEL,
  'xlsb': FileTypes.EXCEL,
  'xlt': FileTypes.EXCEL,
  'xltm': FileTypes.EXCEL,
  'xltx': FileTypes.EXCEL,
  'ods': FileTypes.EXCEL,
  'ots': FileTypes.EXCEL,
  'gsheet': FileTypes.EXCEL,
  'numbers': FileTypes.EXCEL,

  // POWERPOINT files
  'ppt': FileTypes.POWERPOINT,
  'pptx': FileTypes.POWERPOINT,
  'pptm': FileTypes.POWERPOINT,
  'ppsx': FileTypes.POWERPOINT,
  'pps': FileTypes.POWERPOINT,
  'ppsm': FileTypes.POWERPOINT,
  'potx': FileTypes.POWERPOINT,
  'potm': FileTypes.POWERPOINT,
  'odp': FileTypes.POWERPOINT,
  'otp': FileTypes.POWERPOINT,
  'sda': FileTypes.POWERPOINT,
  'sdd': FileTypes.POWERPOINT,
  'sti': FileTypes.POWERPOINT,
  'sxi': FileTypes.POWERPOINT,

  // PDF file
  'pdf': FileTypes.PDF,

  // TEXT file
  'txt': FileTypes.TEXT,

  // ARCHIVE files
  'zip': FileTypes.ZIP,
  'tar': FileTypes.ZIP,
  'gz': FileTypes.ZIP,
  'bz2': FileTypes.ZIP,
  'xz': FileTypes.ZIP,
  'lz': FileTypes.ZIP,
  'z': FileTypes.ZIP,
  'lzma': FileTypes.ZIP,
  'lzo': FileTypes.ZIP,
  'rz': FileTypes.ZIP,
  'sfark': FileTypes.ZIP,
  'ace': FileTypes.ZIP,
  'alz': FileTypes.ZIP,
  'arc': FileTypes.ZIP,
  'arj': FileTypes.ZIP,
  'cab': FileTypes.ZIP,
  'cfs': FileTypes.ZIP,
  'cpt': FileTypes.ZIP,
  'dar': FileTypes.ZIP,
  'dgc': FileTypes.ZIP,
  'dmg': FileTypes.ZIP,
  'kgb': FileTypes.ZIP,
  'lha': FileTypes.ZIP,
  'lzh': FileTypes.ZIP,
  'pak': FileTypes.ZIP,
  'partimg': FileTypes.ZIP,
  'paq8': FileTypes.ZIP,
  'pea': FileTypes.ZIP,
  'pim': FileTypes.ZIP,
  'pit': FileTypes.ZIP,
  'qda': FileTypes.ZIP,
  'rar': FileTypes.ZIP,
  'rk': FileTypes.ZIP,
  's7z': FileTypes.ZIP,
  'sit': FileTypes.ZIP,
  'sitx': FileTypes.ZIP,
  'sqx': FileTypes.ZIP,
  'tgz': FileTypes.ZIP,
  'zipx': FileTypes.ZIP,

  // CODE files
  'c': FileTypes.CODE,
  'cpp': FileTypes.CODE,
  'cs': FileTypes.CODE,
  'java': FileTypes.CODE,
  'js': FileTypes.CODE,
  'py': FileTypes.CODE,
  'rb': FileTypes.CODE,
  'go': FileTypes.CODE,
  'rs': FileTypes.CODE,
  'ts': FileTypes.CODE,
  'html': FileTypes.CODE,
  'css': FileTypes.CODE,
  'scss': FileTypes.CODE,
  'less': FileTypes.CODE,
  'php': FileTypes.CODE,
  'pl': FileTypes.CODE,
  'swift': FileTypes.CODE,
  'kt': FileTypes.CODE,
  'lua': FileTypes.CODE,
  'r': FileTypes.CODE,
  'xml': FileTypes.CODE,
  'json': FileTypes.CODE,
  'yml': FileTypes.CODE,
  'yaml': FileTypes.CODE,
  'md': FileTypes.CODE,
  'markdown': FileTypes.CODE,
  'sql': FileTypes.CODE,
  'ini': FileTypes.CODE,
  'conf': FileTypes.CODE,
  'config': FileTypes.CODE,

  // IMAGE files
  'bmp': FileTypes.IMAGE,
  'gif': FileTypes.IMAGE,
  'ico': FileTypes.IMAGE,
  'jfif': FileTypes.IMAGE,
  'jpeg': FileTypes.IMAGE,
  'jpg': FileTypes.IMAGE,
  'png': FileTypes.IMAGE,
  'svg': FileTypes.IMAGE,
  'tif': FileTypes.IMAGE,
  'tiff': FileTypes.IMAGE,
  'webp': FileTypes.IMAGE,
  'heif': FileTypes.IMAGE,
  'bpg': FileTypes.IMAGE,
  'cgm': FileTypes.IMAGE,
  'drw': FileTypes.IMAGE,
  'dxf': FileTypes.IMAGE,
  'emf': FileTypes.IMAGE,
  'eps': FileTypes.IMAGE,
  'img': FileTypes.IMAGE,
  'jbig2': FileTypes.IMAGE,
  'jp2': FileTypes.IMAGE,
  'jxr': FileTypes.IMAGE,
  'pgf': FileTypes.IMAGE,
  'pld': FileTypes.IMAGE,
  'tga': FileTypes.IMAGE,
  'xcf': FileTypes.IMAGE,
  'xpm': FileTypes.IMAGE,

  // VIDEO files
  'mov': FileTypes.MOVIE,
  'mp4': FileTypes.MOVIE,
  'avi': FileTypes.MOVIE,
  'flv': FileTypes.MOVIE,
  'mkv': FileTypes.MOVIE,
  'mpg': FileTypes.MOVIE,
  'wmv': FileTypes.MOVIE,
  'ogv': FileTypes.MOVIE,
  'gifv': FileTypes.MOVIE,
  'mng': FileTypes.MOVIE,
  'mts': FileTypes.MOVIE,
  'm2ts': FileTypes.MOVIE,
  'rmvb': FileTypes.MOVIE,
  'viv': FileTypes.MOVIE,
  'asf': FileTypes.MOVIE,
  'amv': FileTypes.MOVIE,
  'mp2': FileTypes.MOVIE,
  'mpeg': FileTypes.MOVIE,
  'mpe': FileTypes.MOVIE,
  'mpv': FileTypes.MOVIE,
  'm2v': FileTypes.MOVIE,
  'm4v': FileTypes.MOVIE,
  'svi': FileTypes.MOVIE,
  '3gp': FileTypes.MOVIE,
  '3g2': FileTypes.MOVIE,
  'mxf': FileTypes.MOVIE,
  'roq': FileTypes.MOVIE,
  'nsv': FileTypes.MOVIE,
  'f4v': FileTypes.MOVIE,
  'f4p': FileTypes.MOVIE,
  'f4a': FileTypes.MOVIE,
  'f4b': FileTypes.MOVIE,

  // AUDIO files
  'aif': FileTypes.AUDIO,
  'cda': FileTypes.AUDIO,
  'mp3': FileTypes.AUDIO,
  'mpa': FileTypes.AUDIO,
  'wav': FileTypes.AUDIO,
  'wma': FileTypes.AUDIO,
  'aa': FileTypes.AUDIO,
  'aac': FileTypes.AUDIO,
  'aax': FileTypes.AUDIO,
  'act': FileTypes.AUDIO,
  'aiff': FileTypes.AUDIO,
  'alac': FileTypes.AUDIO,
  'amr': FileTypes.AUDIO,
  'ape': FileTypes.AUDIO,
  'au': FileTypes.AUDIO,
  'awp': FileTypes.AUDIO,
  'dss': FileTypes.AUDIO,
  'dvf': FileTypes.AUDIO,
  'flac': FileTypes.AUDIO,
  'gsm': FileTypes.AUDIO,
  'm4a': FileTypes.AUDIO,
  'm4b': FileTypes.AUDIO,
  'm4p': FileTypes.AUDIO,
  'mmf': FileTypes.AUDIO,
  'movpkg': FileTypes.AUDIO,
  'mpc': FileTypes.AUDIO,
  'msv': FileTypes.AUDIO,
  'nmf': FileTypes.AUDIO,
  'ogg': FileTypes.AUDIO,
  'oga': FileTypes.AUDIO,
  'mogg': FileTypes.AUDIO,
  'opus': FileTypes.AUDIO,
  'ra': FileTypes.AUDIO,
  'rm': FileTypes.AUDIO,
  'raw': FileTypes.AUDIO,
  'rf64': FileTypes.AUDIO,
  'sln': FileTypes.AUDIO,
  'tta': FileTypes.AUDIO,
  'voc': FileTypes.AUDIO,
  'vox': FileTypes.AUDIO,
  'wv': FileTypes.AUDIO,
  'webm': FileTypes.AUDIO,
  '8svx': FileTypes.AUDIO,

  // EXECUTABLE files
  'bat': FileTypes.EXECUTABLE,
  'sh': FileTypes.EXECUTABLE,
  'bin': FileTypes.EXECUTABLE,
  'cmd': FileTypes.EXECUTABLE,
  'com': FileTypes.EXECUTABLE,
  'cpl': FileTypes.EXECUTABLE,
  'dll': FileTypes.EXECUTABLE,
  'exe': FileTypes.EXECUTABLE,
  'msi': FileTypes.EXECUTABLE,
};
